import EditAnimalCampaignForm from "../EditCampaignModal/EditAnimalCampaignForm";
import EditCapitalCampaignForm from "../EditCampaignModal/EditCapitalCampaignForm";

function CampaignDetailsPage({ campaign, onBack }) {
  return (
    <div className="flex-1 bg-gray-100 min-h-screen p-10">
      <div className="max-w-5xl mx-auto">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-gray-500 hover:text-gray-700 mb-6 !font-montserrat !text-[14px]"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Dashboard
        </button>
        <h1 className="!text-orange !text-[30px] !font-semibold !font-poppins !leading-[40px] text-center mb-6">
          Campaign Details
        </h1>
        <div className="bg-white rounded-2xl shadow-md p-8">
          {campaign.campaign_type === "animal" ? (
            <EditAnimalCampaignForm
              campaignId={campaign.id}
              campaignInfo={campaign}
              onClose={onBack}
            />
          ) : (
            <EditCapitalCampaignForm
              campaignId={campaign.id}
              campaignData={campaign}
              onClose={onBack}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CampaignDetailsPage;
